import { render, staticRenderFns } from "./RealVehicleDetail.vue?vue&type=template&id=5c507da6&scoped=true&"
import script from "./RealVehicleDetail.vue?vue&type=script&lang=js&"
export * from "./RealVehicleDetail.vue?vue&type=script&lang=js&"
import style0 from "./RealVehicleDetail.vue?vue&type=style&index=0&id=5c507da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c507da6",
  null
  
)

export default component.exports